<app-sample-status-filters
    [values]="filterValues"
    (filterChange)="onFilterChange($event)"
>
</app-sample-status-filters>
